import styled from 'styled-components'

export const DatLabelText = styled.span`
  width: 40%;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
`
